import { render, staticRenderFns } from "./calfSelectionSelected.vue?vue&type=template&id=5bac7140&scoped=true&"
import script from "./calfSelectionSelected.vue?vue&type=script&lang=js&"
export * from "./calfSelectionSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac7140",
  null
  
)

export default component.exports